import React from 'react';
import { Box, Typography, Stack, Button, TextField, MenuItem, Backdrop, CircularProgress } from '@mui/material';
import { EmailOutlined, SmsOutlined, QrCodeOutlined } from '@mui/icons-material';
import Swal from "sweetalert2";
import QRCode from 'qrcode'
import { LoadingButton } from '@mui/lab';

const IdVerse = () => {
    const [loading, setLoading] = React.useState(false);
    const [selectedButton, setSelectedButton] = React.useState('sms');
    const [countryCode, setCountryCode] = React.useState('+1');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [reference, setReference] = React.useState('');
    const [swalAlert, setSwalAlert] = React.useState(null);
    const [previousStatus, setPreviousStatus] = React.useState(null);
    const [firstName, setFirstName] = React.useState('');
    const [middleName, setMiddleName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    
    const storeVerificationSession = async () => {
        setLoading(true);
        try {
            let url = '';
            let data = {};
            if (selectedButton === 'sms') {
                url = '/api/idverse/sendSMS';
                const isValidPhoneNumber = (phoneNumber) => {
                    const phoneRegex = /^\d{10}$/;
                    return phoneRegex.test(phoneNumber);
                };

                if (!isValidPhoneNumber(phoneNumber)) {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: "Invalid phone number.",
                        confirmButtonText: "OK",
                    });
                    return;
                }
                data = {
                    phoneCode: countryCode,
                    phoneNumber: phoneNumber
                };
            } else if (selectedButton === 'email') {
                url = '/api/idverse/sendEmail';
                const isValidEmail = (email) => {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emailRegex.test(email);
                };

                if (!isValidEmail(email)) {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: "Invalid email address.",
                        confirmButtonText: "OK",
                    });
                    return;
                }
                data = {
                    email: email
                };
            } else {
                url = '/api/idverse/transaction';
            }
            
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ ...data, reference, firstName, middleName, lastName })
            }).then((response) => {
                setLoading(false);
                if (!response.ok) throw new Error(response.statusText);
                return response.json();
            })
            .then((data) => {
                console.info ('Transaction stored successfully', data);
                handleTransactionResponse(data);
            })
            
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const handleTransactionResponse = (data) => {
        if (selectedButton === 'qr' && data.status === 'success') {
            
            QRCode.toDataURL(`https://staging.optum.idkit.co/${data.transactionId}`)
            .then(url => {
                Swal.fire({
                    html: `<img src="${url}" />`,
                    confirmButtonText: "Cancel"
                }).then(() => {
                    checkTransactionStatus(data.transactionId);
                });
            })
            .catch(err => {
                console.error(err)
            })
            
        }
        else if (data.status === 'success') {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Verification Process initiated successfully.",
                confirmButtonText: "Close"
            }).then(() => {
                checkTransactionStatus(data.transactionId);
            });
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Transaction creation failed.",
                confirmButtonText: "OK"
            });
            setLoading(false);
        }
    }

    const checkTransactionStatus = (transactionId) => {
        console.info('Checking transaction status', transactionId);
        fetch(`/api/idverse/transaction/${transactionId}`)
            .then((response) => {
                if (!response.ok) throw new Error(response.statusText);
                return response.json();
            })
            .then((data) => {
                if (data.status === 'COMPLETED_PASS') {
                    let userDocument = data.results.documents[0];

                    let isDataValid = true;
                    let message = '';

                    if (userDocument.confirmedData.dateOfBirth !== userDocument.extractedData.dateOfBirth) {
                        isDataValid = false;
                        message = 'Date of Birth does not match with Barcode Birth Date';
                    }
                    else if (userDocument.confirmedData.expiryDate !== userDocument.extractedData.expiryDate) {
                        isDataValid = false;
                        message = 'Date of Expiry does not match with Barcode Expiry Date';
                    }
                    else if (userDocument.confirmedData.expiryDate != null && new Date(userDocument.confirmedData.expiryDate) <= new Date()) {
                        isDataValid = false;
                        message = 'Document has expired';
                    }

                    const currentDate = new Date();
                    const dateOfBirth = new Date(userDocument.confirmedData.dateOfBirth);
                    const ageDiff = currentDate.getFullYear() - dateOfBirth.getFullYear();
                    const monthDiff = currentDate.getMonth() - dateOfBirth.getMonth();
                    const dayDiff = currentDate.getDate() - dateOfBirth.getDate();

                    if (ageDiff < 18 || (ageDiff === 18 && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)))) {
                        isDataValid = false;
                        message = 'User must be at least 18 years old';
                    }

                    if (isDataValid) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Verification completed successfully by the user.',
                            confirmButtonText: 'OK',
                        // }).then(() => {
                        //     createIssuanceRequest();
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: message,
                            confirmButtonText: 'OK',
                        });
                    }
                    setLoading(false);
                } else if (data.status === 'PENDING' || data.status === 'INPROGRESS') {
                    setTimeout(() => checkTransactionStatus(transactionId), 4000);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Verification failed.',
                        confirmButtonText: 'OK',
                    });
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };
    
    const checkVerificationStatus = (id) => {
        console.info('Checking verification status', id);
        fetch(`/api/verified-id/request-status/${id}`)
        .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
        })
        .then((data) => {
            let sweetAlert = null;

            if (previousStatus === data.status) {
                setTimeout(() => checkVerificationStatus(id), 4000);
                return;
            }
            setPreviousStatus(data.status);

            switch (data.status) {
                case 'verification_request_created':
                case 'issuance_request_created':
                    setTimeout(() => checkVerificationStatus(id), 4000);
                    break;
                case 'request_completed':
                case 'presentation_verified':
                case 'issuance_successful':
                case 'issuance_error':
                    swalAlert?.close();
                    sweetAlert = Swal.fire({
                        html: data.message,
                        confirmButtonText: "Cancel"
                    })
                    break;
                default:
                    swalAlert?.close();
                    sweetAlert = Swal.fire({
                        html: data.message,
                        confirmButtonText: "Cancel"
                    })
                    setTimeout(() => checkVerificationStatus(id), 4000);
                    break;
            }
            setSwalAlert(sweetAlert);
        })
        .catch((error) => {
            console.error(error);
        });
    };

    const createIssuanceRequest = () => {
        setLoading(true);
        console.info('Creating issuance request');
        fetch(`/api/verified-id/issuer/issuance-request`)
        .then((response) => {
            setLoading(false);
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
        })
        .then((data) => {
            handleIssuanceResponse(data, false);
        });
    };

    const handleIssuanceResponse = (data, isPresentation) => {
        console.info('Issuance response', data);
        QRCode.toDataURL(data.url)
        .then(url => {
            checkVerificationStatus(data.requestId);

            const qrHtml = isPresentation
                ? `${data.url}</br><img src="${url}" />`
                : `<img src="${url}" /><br/>Pin: ${data.pin}`;

            const sweetAlert = Swal.fire({
                html: `${qrHtml}<br/><input id="smsPhoneInput" class="swal2-input" placeholder="+18564004672" />`,
                showCancelButton: true,
                confirmButtonText: "Send SMS",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: () => {
                    const phoneNumberInput = Swal.getPopup().querySelector('#smsPhoneInput').value.trim();

                    if (!/^\+\d{10,15}$/.test(phoneNumberInput)) {
                        Swal.showValidationMessage('Enter a phone number in E.164 format, e.g. +18564004672');
                        return false;
                    }

                    return fetch('/api/prove/sms', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ phoneNumber: phoneNumberInput, messageText: data.url })
                    })
                    .then((response) => {
                        if (!response.ok) throw new Error(response.statusText);
                        return response.json();
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Failed to send SMS: ${error.message}`);
                        return false;
                    });
                }
            });

            sweetAlert.then((result) => {
                if (result.isConfirmed && result.value) {
                    Swal.fire({
                        icon: 'success',
                        title: 'SMS Sent',
                        text: 'The link has been sent to the provided phone number.',
                        confirmButtonText: 'OK'
                    });
                }
            });

            setSwalAlert(sweetAlert);
        })
    };


    const createPresentationRequest = () => {
        setLoading(true);
        console.info('Creating presentation request');
        fetch(`/api/verified-id/verifier/presentation-request`)
        .then((response) => {
            setLoading(false);
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
        })
        .then((data) => {
            handleIssuanceResponse(data, true);
        });
    };

    const countryCodes = [
        { code: '+1', country: 'United States' },
        { code: '+91', country: 'India' },
        { code: '+44', country: 'United Kingdom' },
        { code: '+33', country: 'France' },
        { code: '+49', country: 'Germany' },
        { code: '+81', country: 'Japan' },
        { code: '+61', country: 'Australia' },
        { code: '+55', country: 'Brazil' },
        { code: '+52', country: 'Mexico' },
        { code: '+39', country: 'Italy' },
        { code: '+34', country: 'Spain' },
        { code: '+82', country: 'South Korea' },
        { code: '+46', country: 'Sweden' },
        { code: '+31', country: 'Netherlands' },
        { code: '+41', country: 'Switzerland' },
        // { code: '+63', country: 'Philippines', },
        { code: '+64', country: 'New Zealand' },
        { code: '+55', country: 'Argentina' },
    ];

    return (
        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box display="flex"
                flexDirection="column"
                alignItems="center"
                borderRadius='12px'
                boxShadow='2'
                width='1000px'
                height='500px'
                style={{ marginTop: '20px' }}
                >
                <Typography variant="h5" component="h2" style={{ marginTop: '30px' }}>
                    IDVerse - Identity Verification
                </Typography>
                <Stack direction="row" spacing={2} style={{ marginTop: '30px' }}>
                    <Button
                        variant="outlined"
                        startIcon={<SmsOutlined />}
                        onClick={() => setSelectedButton('sms')}
                        disabled={selectedButton === 'sms'}
                    >
                        Send SMS
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<EmailOutlined />}
                        onClick={() => setSelectedButton('email')}
                        disabled={selectedButton === 'email'}
                    >
                        Send Email
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<QrCodeOutlined />}
                        onClick={() => setSelectedButton('qr')}
                        disabled={selectedButton === 'qr'}
                    >
                        Scan QR
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<QrCodeOutlined />}
                        onClick={() => createPresentationRequest()}
                        disabled={selectedButton === 'qr'}
                    >
                        Already have a verified ID?
                    </Button>
                    <Button
                        variant="outlined"
                        startIcon={<QrCodeOutlined />}
                        onClick={() => createIssuanceRequest()}
                        disabled={selectedButton === 'qr'}
                    >
                        New Issuance
                    </Button>
                </Stack>
                <Stack direction="row" spacing={2} style={{ marginTop: '40px' }}>
                    {selectedButton === 'sms' && (
                        <>
                            <Typography variant="h6" component="h2" style={{ alignContent: 'center' }}>
                                Method: SMS
                            </Typography>
                            <TextField
                                select
                                label="Country Code"
                                id="codeInput"
                                value={countryCode}
                                onChange={(event) => setCountryCode(event.target.value)}
                            >
                                {countryCodes.map((country) => (
                                    <MenuItem key={country.code} value={country.code}>
                                        {`${country.country} (${country.code})`}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                label="Phone Number"
                                placeholder="Phone Number"
                                id="phoneNumberInput"
                                value={phoneNumber}
                                onChange={(event) => setPhoneNumber(event.target.value)}
                            />
                        </>
                    )}
                    {selectedButton === 'email' && (
                        <>
                            <Typography variant="h6" component="h2" style={{ alignContent: 'center' }}>
                                Method: Email
                            </Typography>
                            <TextField
                                label="Email"
                                placeholder="Email"
                                id="emailInput"
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                            />
                        </>
                    )}
                    {selectedButton === 'qr' && (
                        <Typography variant="h6" component="h2">
                            Method: QR Code
                        </Typography>
                    )}
                </Stack>
                <Stack direction="row" spacing={2} style={{ marginTop: '30px' }}>
                    <TextField
                        label="First Name"
                        placeholder="First Name"
                        id="firstNameInput"
                        value={firstName}
                        onChange={(event) => setFirstName(event.target.value)}
                    />
                    <TextField
                        label="Middle Name"
                        placeholder="Middle Name"
                        id="middleNameInput"
                        value={middleName}
                        onChange={(event) => setMiddleName(event.target.value)}
                    />
                    <TextField
                        label="Last Name"
                        placeholder="Last Name"
                        id="lastNameInput"
                        value={lastName}
                        onChange={(event) => setLastName(event.target.value)}
                    />
                </Stack>
                <Stack direction="row" spacing={2} style={{ marginTop: '30px' }}>
                    <Typography variant="h6" component="h2" style={{ alignContent: 'center' }}>
                        Reference
                    </Typography>
                    <TextField
                        label="MSID"
                        placeholder="MSID"
                        id="referenceInput"
                        value={reference}
                        onChange={(event) => setReference(event.target.value)}
                    />
                </Stack>
                <Stack direction="row" spacing={2} style={{ marginTop: '30px' }}>
                    <LoadingButton
                        variant="contained" color="secondary"
                        loading={loading}
                        onClick={() => {
                            setCountryCode('+1');
                            setPhoneNumber('');
                            setEmail('');
                            setReference('');
                        }}
                    >
                        Reset
                    </LoadingButton>
                    <LoadingButton
                        variant="contained" color="success"
                        loading={loading}
                        onClick={storeVerificationSession}
                    >
                        Submit
                    </LoadingButton>
                </Stack>
            </Box>
        </div>
    );
};

export default IdVerse;
